import * as React from 'react';
import * as _ from 'lodash';
export default function () {
    return React.createElement('div', { 'id': 'EmailVerify' });
}